import Navigation from "./Navigation";
import Footer from "./Footer";

function Layout({ children }) {
  return (
    <div className="min-h-screen bg-bg-primary flex flex-col">
      <Navigation />
      <main className="flex-1 container mx-auto px-4 py-8">
        {children}
      </main>
      <Footer />
    </div>
  );
}

export default Layout;
